// extracted by mini-css-extract-plugin
export default {"scrollableTerms":"ep9D8gMbsPNyOJ4PWnrc"};